<template>
  <div class="reg-queue-container">
    <div class="content-section">
      <div class="section-header">
        <div class="section-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-2.5 5M7 13l2.5 5m6-5v6a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-6m8 0V9a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v4.01"/>
          </svg>
        </div>
        <h2>Táncosok Regisztrációs Sorrendje</h2>
        <p>{{ isTeacher && !isAdmin ? 'Hozzárendelt csoportok regisztrációs sorrendje' : 'Regisztrációs sorrend és csoport szűrés' }}</p>
      </div>
      
      <div class="section-content">
        <!-- Group Filter -->
        <div class="filter-section">
          <div class="filter-group">
            <label for="groupFilter" class="filter-label">Válassz egy csoportot:</label>
            <select v-model="selectedGroup" class="modern-select" id="groupFilter">
              <option value="">Összes csoport</option>
              <option v-for="group in groups" :key="group.id" :value="group.name">
                {{ group.name }}
              </option>
            </select>
          </div>
        </div>

        <!-- Table Section -->
        <div class="table-section">
          <div class="table-header">
            <h3>Regisztrációs Lista</h3>
            <span class="count-badge">{{ filteredChildren.length }} táncos</span>
          </div>
          
          <div class="modern-table-container">
            <table class="modern-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Vezetéknév</th>
                  <th>Keresztnév</th>
                  <th>Csoport</th>
                </tr>
              </thead>
              <tbody>
                <tr 
                  v-for="child in filteredChildren" 
                  :key="child.child_id" 
                  @click="goToUniqueChildPage(child.main_user_id)"
                  class="table-row"
                >
                  <td class="position-cell">{{ child.reg_place }}</td>
                  <td>{{ child.child_family_name }}</td>
                  <td>{{ child.child_sure_name }}</td>
                  <td>
                    <span class="group-badge">{{ child.group_name }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
  export default {
    data() {
      return {
        children: [],
        groups: [],
        selectedGroup: "", // Stores the selected group name
        isAdmin: false,
        isTeacher: false,
        userId: null
      };
    },
    computed: {
      filteredChildren() {
        // If no group is selected, show all children
        if (!this.selectedGroup) {
          return this.children;
        }
        // Otherwise, filter by selected group name
        return this.children.filter(child => child.group_name === this.selectedGroup);
      },
    },
    methods: {
      getIsAdmin() {
        this.isAdmin = this.$isAdmin();
      },
      getIsTeacher() {
        this.isTeacher = this.$isTeacher();
      },
      getUserId() {
        this.userId = this.$getUserId();
      },
      async fetchGroups() {
        try {
          const response = await fetch(`${this.$BACKEND_HOST}/api/settings/children/register-queue`);
          const data = await response.json();
          
          // If user is a teacher, filter to only show children from their assigned groups
          if (this.isTeacher && !this.isAdmin) {
            const teacherId = this.userId;
            if (!teacherId) {
              throw new Error('Teacher ID not found');
            }
            
              // Get teacher's assigned groups
              const teacherResponse = await fetch(`${this.$BACKEND_HOST}/api/settings/teachers/groups?teacher_id=${teacherId}`);
              if (teacherResponse.ok) {
                const teacherData = await teacherResponse.json();
                const assignedGroupIds = teacherData.groups.map(g => g.id);

                if (assignedGroupIds.length === 0) {
                  this.children = data.reg_queue;
                } else {
                  this.children = data.reg_queue.filter(child =>
                    assignedGroupIds.includes(child.child_desired_group) ||
                    (child.child_current_group_id != null && assignedGroupIds.includes(child.child_current_group_id))
                  );
                }
              } else {
                this.children = [];
              }
          } else {
            // For admin users, show all children
            this.children = data.reg_queue;
          }
          
          console.log(data);
          this.getGroups();
        } catch (error) {
          console.error("Error fetching groups:", error);
        }
      },
      async getGroups() {
        try {
          const response = await fetch(`${this.$BACKEND_HOST}/api/settings/groups/info`);
          const data = await response.json();
          this.groups = data.groups; // Store groups for the dropdown
  
          if (this.children.length > 0) {
            let i = 1;
            this.children.forEach(child => {
                child.reg_place = i++;
              const group = this.groups.find(g => g.id === child.child_desired_group);
              if (group) {
                child.group_name = group.name;
              }
            });
          }
        } catch (error) {
          console.error("Error fetching group info:", error);
        }
      },
      goToUniqueChildPage(id) {
        this.$router.push(`/dancer/${id}`);
      },
    },
    mounted() {
      this.getIsAdmin();
      this.getIsTeacher();
      this.getUserId();
      this.fetchGroups(); // Initial fetch
    },
  };
  </script>
  
  <style scoped>
  .reg-queue-container {
    padding: 2rem;
    max-width: 1200px;
    margin: 0 auto;
  }

  .content-section {
    background: var(--card-bg);
    border-radius: 16px;
    box-shadow: var(--shadow);
    border: 1px solid var(--color-border);
    overflow: hidden;
  }

  .section-header {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 1.5rem 2rem;
    background: var(--color-background-mute);
    border-bottom: 1px solid var(--color-border);
  }

  .section-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));
    border-radius: 8px;
    color: white;
    flex-shrink: 0;
  }

  .section-header h2 {
    color: var(--color-heading);
    font-size: 1.5rem;
    font-weight: 600;
    margin: 0;
  }

  .section-header p {
    color: var(--color-text-muted);
    font-size: 0.95rem;
    margin: 0;
    margin-left: auto;
  }

  .section-content {
    padding: 2rem;
  }

  .filter-section {
    margin-bottom: 2rem;
    padding-bottom: 1.5rem;
    border-bottom: 1px solid var(--color-border);
  }

  .filter-group {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    max-width: 300px;
  }

  .filter-label {
    color: var(--color-heading);
    font-size: 0.95rem;
    font-weight: 500;
    margin: 0;
  }

  .modern-select {
    padding: 0.75rem 1rem;
    border: 2px solid var(--color-border);
    border-radius: 8px;
    background: var(--card-bg);
    color: var(--color-text);
    font-size: 0.95rem;
    transition: all 0.3s ease;
    outline: none;
  }

  .modern-select:focus {
    border-color: var(--primary-blue);
    box-shadow: 0 0 0 3px rgba(var(--primary-blue-rgb), 0.1);
  }

  .modern-select:hover {
    border-color: var(--primary-blue);
  }

  .table-section {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .table-header h3 {
    color: var(--color-heading);
    font-size: 1.25rem;
    font-weight: 600;
    margin: 0;
  }

  .count-badge {
    background: var(--primary-blue);
    color: white;
    padding: 0.25rem 0.75rem;
    border-radius: 12px;
    font-size: 0.875rem;
    font-weight: 500;
  }

  .modern-table-container {
    background: var(--color-background-mute);
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid var(--color-border);
  }

  .modern-table {
    width: 100%;
    border-collapse: collapse;
    background: var(--card-bg);
  }

  .modern-table thead {
    background: var(--color-background-mute);
  }

  .modern-table th {
    padding: 1rem;
    text-align: left;
    color: var(--color-heading);
    font-weight: 600;
    font-size: 0.95rem;
    border-bottom: 1px solid var(--color-border);
  }

  .modern-table td {
    padding: 1rem;
    color: var(--color-text);
    font-size: 0.95rem;
    border-bottom: 1px solid var(--color-border);
  }

  .table-row {
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .table-row:hover {
    background: var(--color-background-mute);
    transform: translateY(-1px);
  }

  .table-row:last-child td {
    border-bottom: none;
  }

  .position-cell {
    font-weight: 600;
    color: var(--primary-blue);
    text-align: center;
    width: 60px;
  }

  .group-badge {
    background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));
    color: white;
    padding: 0.25rem 0.75rem;
    border-radius: 12px;
    font-size: 0.875rem;
    font-weight: 500;
  }

  /* Responsive design */
  @media (max-width: 768px) {
    .reg-queue-container {
      padding: 1rem;
    }

    .section-header {
      padding: 1rem 1.5rem;
    }

    .section-header h2 {
      font-size: 1.25rem;
    }

    .section-content {
      padding: 1.5rem;
    }

    .table-header {
      flex-direction: column;
      align-items: flex-start;
      gap: 0.5rem;
    }

    .modern-table th,
    .modern-table td {
      padding: 0.75rem 0.5rem;
      font-size: 0.875rem;
    }

    .modern-table th:first-child,
    .modern-table td:first-child {
      width: 50px;
    }
  }

  @media (max-width: 480px) {
    .reg-queue-container {
      padding: 0.75rem;
    }

    .section-header {
      padding: 0.75rem 1rem;
    }

    .section-header h2 {
      font-size: 1.125rem;
    }

    .section-content {
      padding: 1rem;
    }

    .modern-table {
      font-size: 0.8rem;
    }

    .modern-table th,
    .modern-table td {
      padding: 0.5rem 0.25rem;
    }

    .group-badge {
      font-size: 0.75rem;
      padding: 0.2rem 0.5rem;
    }
  }
  </style>
  